import { render } from "./contact.vue?vue&type=template&id=07350f98&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=07350f98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07350f98"

export default script